<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>员工管理</el-breadcrumb-item>
            <el-breadcrumb-item>导出信息</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c1" @click="downA"
            >导出人员基本信息(RPA)</el-button
          >
          <el-button type="primary" class="c1" @click="downB"
            >导出人员基本信息(人资)</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c1" @click="downC"
            >导出月度KPI考核信息</el-button
          >
          <el-button type="primary" class="c1" @click="downD"
            >导出季度KPI考核信息</el-button
          >
          <el-button type="primary" class="c2" @click="upA"
            >KPI结果上传</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c1" @click="downE"
            >导出月度KPI人员总分</el-button
          >
          <el-button type="primary" class="c1" @click="downF"
            >导出季度KPI人员总分</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c2" @click="upB"
            >KPI计划更新</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c2" @click="upC"
            >批量导入晋降级信息</el-button
          >
          <el-button type="primary" class="c2" @click="upD"
            >批量导入调动信息</el-button
          >
          <el-button type="primary" class="c2" @click="upE"
            >批量导入转正信息</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c1" @click="downG"
            >导出上月考勤信息</el-button
          >
          <el-button type="primary" class="c1" @click="downH"
            >导出上月考勤汇总信息</el-button
          >
          <el-button type="primary" class="c1" @click="downI"
            >导出产假信息</el-button
          >
          <el-button type="primary" class="c1" @click="downJ"
            >导出教育基金信息</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c1" @click="downK"
            >导出本月考勤信息</el-button
          >
          <el-button type="primary" class="c1" @click="downL"
            >导出本月考勤汇总信息</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c2" @click="upF"
            >批量导入修改后考勤汇总信息</el-button
          >
        </el-col>
        <el-col style="text-align: left;margin:0 0 20px 300px;">
          <el-button type="primary" class="c2" @click="upG"
            >批量导入休息日人员上班信息</el-button
          >
        </el-col>
      </el-row>
      <el-dialog :title="downTitle" :visible.sync="downDialog" width="40%">
        <div class="datebox" style="margin-left:20px;">
          <div>
            <h5>选择年份：</h5>
            <el-select v-model="value1" placeholder="请选择年份">
              <el-option value="2016">2016</el-option>
              <el-option value="2017">2017</el-option>
              <el-option value="2018">2018</el-option>
              <el-option value="2019">2019</el-option>
              <el-option value="2020">2020</el-option>
              <el-option value="2021">2021</el-option>
              <el-option value="2022">2022</el-option>
              <el-option value="2023">2023</el-option>
              <el-option value="2024">2024</el-option>
              <el-option value="2025">2025</el-option>
              <el-option value="2026">2026</el-option>
              <el-option value="2027">2027</el-option>
              <el-option value="2028">2028</el-option>
              <el-option value="2029">2029</el-option>
              <el-option value="2030">2030</el-option>
            </el-select>
          </div>
          <div v-if="isMonth" style="margin-bottom:20px;">
            <h5>选择月份：</h5>
            <el-select v-model="value2" placeholder="请选择月份">
              <el-option value="1">1</el-option>
              <el-option value="2">2</el-option>
              <el-option value="3">3</el-option>
              <el-option value="4">4</el-option>
              <el-option value="5">5</el-option>
              <el-option value="6">6</el-option>
              <el-option value="7">7</el-option>
              <el-option value="8">8</el-option>
              <el-option value="9">9</el-option>
              <el-option value="10">10</el-option>
              <el-option value="11">11</el-option>
              <el-option value="12">12</el-option>
            </el-select>
          </div>
          <div v-if="!isMonth" style="margin-bottom:20px;">
            <h5>选择季度：</h5>
            <el-select v-model="value3" placeholder="请选择季度">
              <el-option value="Q1">Q1</el-option>
              <el-option value="Q2">Q2</el-option>
              <el-option value="Q3">Q3</el-option>
              <el-option value="Q4">Q4</el-option>
            </el-select>
          </div>
          <el-button type="primary" class="c1" @click="downLoad"
            >导出</el-button
          >
        </div>
      </el-dialog>
      <el-dialog :title="upTitle" :visible.sync="upDialog" width="40%">
        <h5>说明：</h5>
        <p>1、请严格按照模板格式进行填写数据，否则可能导入失败；</p>
        <p>2、填写的数据中不可出现空格和换行符；</p>
        <p>3、填写的邮箱，手机和信用证号确定存在，否则导入失败。</p>
        <div class="upbox">
          <h5>选择EXCEL文件：</h5>
          <!-- <input type="file" id="file" /> -->
          <el-upload
            class="upload-demo"
            action="http://hr.text.ruizhiqi.com/publicApi/Exported/UploadImportFile"
            name="file_head"
            :limit="1"
            :file-list="fileList"
            accept=".xls,.xlsx"
            :on-success="handleChangeUpload"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary" class="upbtn"
              >选择文件</el-button
            >
          </el-upload>
          <br />
          <el-button
            size="small"
            type="primary"
            v-if="fileName != ''"
            style="float:none;margin:30px 0 0 100px;"
            @click="goUp"
            >确定</el-button
          >
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { cryptoDecode } from "../../until/encrypt.js";
export default {
  data() {
    return {
      downTitle: "",
      downDialog: false,
      value1: "",
      value2: "",
      value3: "",
      isMonth: true,
      upTitle: "",
      upDialog: false,
      LoadUrl:
        "http://hr.text.ruizhiqi.com/publicApi/Exported/UploadImportFile",
      uphead: "",
      files: {},
      fileName: "",
      filedata: {
        name: "file_head"
      },
      fileList: [],
      fileraw: {}
    };
  },
  created() {},
  methods: {
    downA() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportToExcel";
    },
    downB() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportToExcelByHR";
    },
    downC() {
      this.downTitle = "批量导出月度KPI考核结果";
      this.downDialog = true;
      this.isMonth = true;
    },
    downD() {
      this.downTitle = "批量导出季度KPI考核结果";
      this.downDialog = true;
      this.isMonth = false;
    },
    downE() {
      this.downTitle = "批量导出月度KPI人员总分";
      this.downDialog = true;
      this.isMonth = true;
    },
    downF() {
      this.downTitle = "批量导出季度KPI人员总分";
      this.downDialog = true;
      this.isMonth = false;
    },
    downG() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/AttendanceToExcel";
    },
    downH() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/AttendanceAllToExcel";
    },
    downI() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/PregnancyToExcel";
    },
    downJ() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/EducationToExcel";
    },
    downK() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/AttendanceNowToExcel";
    },
    downL() {
      window.location.href =
        "http://hr.text.ruizhiqi.com/publicApi/Exported/AttendanceNowAllToExcel";
    },
    downLoad() {
      if (this.downTitle == "批量导出月度KPI考核结果") {
        if (this.value1 == "") {
          this.$message.warning("请选择年份！");
          return;
        }
        if (this.value2 == "") {
          this.$message.warning("请选择月份！");
          return;
        }
        window.location.href =
          "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportKPIToExcel/years/" +
          this.value1 +
          "/peroid/" +
          this.value2 +
          "/kpitype/0";
      }
      if (this.downTitle == "批量导出季度KPI考核结果") {
        if (this.value1 == "") {
          this.$message.warning("请选择年份！");
          return;
        }
        if (this.value3 == "") {
          this.$message.warning("请选择季度！");
          return;
        }
        window.location.href =
          "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportKPIToExcel/years/" +
          this.value1 +
          "/peroid/" +
          this.value3 +
          "/kpitype/1";
      }
      if (this.downTitle == "批量导出月度KPI人员总分") {
        if (this.value1 == "") {
          this.$message.warning("请选择年份！");
          return;
        }
        if (this.value2 == "") {
          this.$message.warning("请选择月份！");
          return;
        }
        window.location.href =
          "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportScodeToExcel/years/" +
          this.value1 +
          "/peroid/" +
          this.value2 +
          "/kpitype/0";
      }
      if (this.downTitle == "批量导出季度KPI人员总分") {
        if (this.value1 == "") {
          this.$message.warning("请选择年份！");
          return;
        }
        if (this.value3 == "") {
          this.$message.warning("请选择季度！");
          return;
        }
        window.location.href =
          "http://hr.text.ruizhiqi.com/publicApi/Exported/ExportScodeToExcel/years/" +
          this.value1 +
          "/peroid/" +
          this.value3 +
          "/kpitype/1";
      }
    },
    upA() {
      this.upTitle = "批量导入KPI考核结果";
      this.upDialog = true;
    },
    upB() {
      this.upTitle = "批量导入人员PKI";
      this.upDialog = true;
    },
    upC() {
      this.upTitle = "批量导入晋降级信息";
      this.upDialog = true;
    },
    upD() {
      this.upTitle = "批量导入调动信息";
      this.upDialog = true;
    },
    upE() {
      this.upTitle = "批量导入转正信息";
      this.upDialog = true;
    },
    upF() {
      this.upTitle = "批量导入修改后考勤汇总信息";
      this.upDialog = true;
    },
    upG() {
      this.upTitle = "批量导入休息日人员上班信息";
      this.upDialog = true;
    },
    // 上传前检测
    beforeUpload(file) {
      this.files = file;
      console.log(file);
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.warning("上传模板大小不能超过 5MB!");
        return;
      }
      this.fileName = file.name;
      // return false; // 返回false不会自动上传
    },
    handleChangeUpload(res) {
      // console.log(res);
      this.fileraw = res.Message;
    },
    // beginLoad(val) {
    //   this.fileraw = val.file;
    // },
    // 开始上传
    goUp() {
      if (this.fileName == "") {
        this.$message.warning("请选择要上传的文件！");
        return false;
      }
      var userinfo = JSON.parse(
        cryptoDecode(window.sessionStorage.getItem("userinfo"))
      );
      var UserId = userinfo.UserId;
      console.log(userinfo);
      if (this.upTitle == "批量导入KPI考核结果") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/OffLineImportSave?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入人员PKI") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/UserKPIImportSave?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入晋降级信息") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/UpDownImportSave?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入调动信息") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/MoveImportSave?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入转正信息") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/RegularImportSave?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入修改后考勤汇总信息") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/UpdateAttendance?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
      if (this.upTitle == "批量导入休息日人员上班信息") {
        $.ajax({
          url:
            "http://hr.text.ruizhiqi.com/publicApi/Exported/UserWorkByRelax?path=" +
            this.fileraw +
            "&curruser=" +
            UserId,
          type: "POST",
          async: false,
          contentType: "application/x-www-form-urlencoded",
          Accept: "application/json",
          success: function(res) {
            alert(res.Message);
          }
        });
      }
    }
  }
};
</script>

<style>
/* .el-button--primary {
  float: none;
} */
.c1 {
  background-color: #337ab7 !important;
  float: none;
}

.c2 {
  background-color: #449d44 !important;
  float: none;
}

.el-dialog__body {
  padding-bottom: 100px !important;
  text-align: left;
}

.upbox {
  margin-top: 20px;
  border-top: 1px dashed #ddd;
  padding: 20px;
}

.upbox .upbtn {
  float: none;
}
</style>
